<template>
  <section
    :class="[
      'tw-flex tw-relative tw-w-fit tw-p-[6px]',
      'tw-gap-[12px] tw-rounded-full tw-justify-center tw-items-center',
      'tw-outline  tw-outline-offset-[-2px] tw-outline-2',
      'tw-cursor-pointer tw-transition-colors tw-duration-100',
      { 'tw-bg-black tw-outline-white': darkMode },
      { 'tw-bg-white tw-outline-ap-gainsboro': !darkMode },
    ]" 
    @click="onClickDaylight"
  >
    <div
      :class="[
        ' tw-absolute tw-w-[28px] tw-h-[28px]',
        'tw-z-[1] tw-rounded-full tw-top-[6px] tw-left-[6px]',
        'tw-transition-all tw-duration-300',
        { 'tw-bg-black': !darkMode },
        { 'tw-bg-white tw-translate-x-[40px]': darkMode },
      ]"
    />
    <div
      :class="[
        'tw-flex tw-justify-center tw-items-center',
        'tw-h-[28px] tw-w-[28px]',
        'tw-z-[2]'
      ]"
    >
      <img :src="$cdn('icons/sidebar/icon_morning.svg')" alt="Daylight morning" :draggable="false" style="user-select: none;">
    </div>
    <div
      :class="[
        'tw-flex tw-justify-center tw-items-center',
        'tw-h-[28px] tw-w-[28px]',
        'tw-z-[2]'
      ]"
    >
      <img :src="$cdn('icons/sidebar/icon_evening.svg')" alt="Daylight evening" :draggable="false" style="user-select: none;">
    </div>
  </section>
</template>

<script setup lang="ts">

// const darkMode = ref(false);
const props = defineProps({
  darkMode: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:darkMode']);

function onClickDaylight() {
  emit('update:darkMode', !props.darkMode);
  if (props.darkMode) {
    document.documentElement.classList.add('dark');
  }else {
    document.documentElement.classList.remove('dark');
  }
}



</script>

<style scoped>
</style>